document.querySelectorAll("[data-resource-files]").forEach((container) => {
    const toggle = container.querySelector("[data-files-toggle]");
    const label = toggle.querySelector("[data-files-toggle-label]");
    const panel = container.querySelector("[data-files-panel]");
    const showLabel = label.textContent.trim();
    const hideLabel = toggle.dataset.labelHide;
    const fileLinks = Array.from(
        container.querySelectorAll("[data-file-name]"),
    );

    const setOpen = (open) => {
        toggle.setAttribute("aria-expanded", String(open));
        panel.classList.toggle("is-open", open);
        label.textContent = open ? hideLabel : showLabel;
    };

    container.classList.add("is-enhanced");
    toggle.hidden = false;
    setOpen(false);

    toggle.addEventListener("click", () => {
        setOpen(toggle.getAttribute("aria-expanded") !== "true");
    });

    container.addEventListener("click", (event) => {
        const link = event.target.closest("a[download]");

        if (!link) {
            return;
        }

        const links = link.hasAttribute("data-download-all")
            ? fileLinks
            : [link];

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "resource_download",
            resource_title: container.dataset.resourceTitle,
            file_count: links.length,
            file_names: links
                .map((fileLink) => fileLink.dataset.fileName)
                .join(", "),
        });
    });
});
